import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomSelect from '../../common/formElements/CustomSelect';
import { findRegionByName } from './common/common_utils';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class XataDatabasesList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedDatabase: '',
    errorMessage: '',
  };
  handleChange = (name, value) => {
    this.setState({ [name]: value.value });
  };

  handleSendRequset = async () => {
    const { actions, location, match, history, dataConnector } = this.props;
    const { state } = location;
    const { headers, dataSourceName, workspaceId } = state;
    const { projectId, version } = match.params;
    const { databasesByXata } = dataConnector;
    const databaseName = this.state.selectedDatabase;
    if (!databaseName) {
      this.setState({ errorMessage: 'Please Choose Any Database !' });
      return;
    }
    const region = findRegionByName(databaseName, databasesByXata);
    const dataForSave = {
      name: dataSourceName,
      projectVersion: version,
      projectId,
      type: 'XATA',
      setting: headers,
      completeData: {
        database: {
          workspaceId: workspaceId,
          region: region,
          name: databaseName,
        },
        tables: [],
      },
    };
    await actions.xataSaveExternalDatabase(dataForSave);
    if (this.props.dataConnector.databasesByXata) {
      const { externalDbUuidXata } = this.props.dataConnector;
      history.push(`/2.0/data-connector/${version}/v/${projectId}/xata/${externalDbUuidXata}`);
    }
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { dataConnector, history, match } = this.props;
    const { projectId, version } = match.params;
    const { databasesByXata, xataSaveExternalDatabasePending } = dataConnector;
    if (!databasesByXata) {
      history.push(`/2.0/data-connector/${version}/v/${projectId}/xata-datasource`);
    }
    const { errorMessage, selectedDatabase } = this.state;
    const databases = databasesByXata
      ? databasesByXata.map((item) => ({
          label: item.name,
          value: item.name,
        }))
      : null;
    return (
      <CommonPageComponent>
        <ParentContentCard title={'Choose Database for Collection'} icon="collection">
          <div className="row justify-content-center ">
            <div className="col-sm-4">
              <CustomSelect
                name="selectedDatabase"
                isMulti={false}
                isObject={true}
                options={databases}
                onBlur={() => {}}
                value={selectedDatabase}
                placeholder="Select database"
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="text-center ml-3">
            {errorMessage && <p className="errors">{errorMessage}</p>}
          </div>
          <div className="text-center ml-3 mt-2">
            <button
              className="btn btn-theme-submit mt-3"
              onClick={this.handleSendRequset}
              disabled={xataSaveExternalDatabasePending}
            >
              <i className="wb webconnect-rocket"></i>
              &nbsp;Continue&nbsp;
              <CustomLoader loading={xataSaveExternalDatabasePending} />
            </button>
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataDatabasesList);
